import type { MapTheme, TerrainOnlyTileKind, Tile, TileKind } from "@dailywars/core/engine";
import { isBuildingTile } from "@dailywars/core/engine";
import { isBridgeRoadTile } from "@dailywars/core/render/roadTerrainBackground";

import { getRoadAutotileImageSrc } from "#/game/roadSprites";
import { getTerrainImageSrc } from "#/game/svgAssets";

export function getRoadTileIconLayers({ theme }: { theme?: MapTheme }): {
  plainSrc: string;
  overlaySrc: string;
} {
  return {
    plainSrc: getTerrainImageSrc({ kind: "plain", x: 0, y: 0, theme }),
    overlaySrc: getRoadAutotileImageSrc({ theme, kind: "straight" }),
  };
}

export function terrainKindForTile(kind: TileKind): TerrainOnlyTileKind {
  if (isBuildingTile(kind) || kind === "road") return "plain";
  return kind;
}

export function terrainKindsForMapTile({
  kind,
  tiles,
  width,
  x,
  y,
}: {
  kind: TileKind;
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): TerrainOnlyTileKind[] {
  if (kind !== "road") return [terrainKindForTile(kind)];
  const kinds: TerrainOnlyTileKind[] = ["plain"];
  if (isBridgeRoadTile({ tiles, width, x, y })) kinds.push("sea");
  return kinds;
}
